import { adminRequestsApi } from 'entities/adminRequest/api/adminRequestsApi';
import { filter, find } from 'lodash-es';
import map from 'lodash-es/map';
import { makeAutoObservable, runInAction } from 'mobx';
import { AdminRequestModel } from 'entities/adminRequest/model/adminRequestModel';
import { RootStore } from 'app/store/rootStore';

export class AdminRequestsStore {
  private _rootStore: RootStore;

  public requests: null | AdminRequestModel[] = null;
  public isPending = false;
  public isError = false;

  constructor({ rootStore }: { rootStore: RootStore }) {
    this._rootStore = rootStore;
    makeAutoObservable(this);
  }

  public async fetch() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      const data = await adminRequestsApi.fetch();
      this.requests = map(data, (item) => new AdminRequestModel(item));
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }

  public async silenceFetch() {
    try {
      const data = await adminRequestsApi.fetch();
      this.requests = map(data, (item) => new AdminRequestModel(item));
    } catch (e) {
      console.error(e);
    }
  }

  private _findById(id: string) {
    return find(this.requests, (r) => r.id === id);
  }

  private _removeItem(id: string) {
    this.requests = filter(this.requests, (r) => r.id !== id);
  }

  public async accept(id: string) {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    const target = this._findById(id);

    if (target) {
      try {
        await target.accept();
        this._removeItem(id);
      } catch (e) {
        runInAction(() => {
          this.isPending = false;
          this.isError = true;
          this._rootStore.notificationsStore.errorMessage =
            'Не удалось принять заявку';
        });
        console.error(e);
      }
    }
  }

  public async decline(id: string) {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    const target = this._findById(id);

    if (target) {
      try {
        await target.decline();
        this._removeItem(id);
        this._rootStore.notificationsStore.successMessage =
          'Заявка успешно отклонена';
      } catch (e) {
        runInAction(() => {
          this.isPending = false;
          this.isError = true;
          this._rootStore.notificationsStore.errorMessage =
            'Не удалось отклонить заявку';
        });
        console.error(e);
      }
    }
  }
}
